// extracted by mini-css-extract-plugin
module.exports = {"root":"_38RZ6","collectionButton":"TTfHg","rightSeparator":"_1xwpN","favoriteButton":"_2SumI","fullscreenButton":"s3ESh"};